// extracted by mini-css-extract-plugin
module.exports = {"center":"SupplierPortalListView_center__14R6W"};